import { createRoute } from '@tanstack/react-router';
import { rootRoute } from '@trashlab/sitesapp/src/routes/__root';
import { DebrisCalculatorHeroSection } from '@trashlab/sitesapp/src/organizations/redebins/template/components/debris-calculator/debris-calculator-hero-section';
import { DebrisCalculatorContent } from '@trashlab/sitesapp/src/organizations/redebins/template/components/debris-calculator/debris-calculator-content';
import { ReadyWhenYouAre } from '@trashlab/sitesapp/src/organizations/redebins/template/components/shared/ready-when-you-are';
import { ServiceAreasSection } from '@trashlab/sitesapp/src/organizations/redebins/template/components/shared/service-areas-section';

const DebrisCalculatorPage = () => {
  return (
    <>
      <DebrisCalculatorHeroSection />
      <DebrisCalculatorContent />
      <ReadyWhenYouAre />
      <ServiceAreasSection />
    </>
  );
};

export const Route = createRoute({
  getParentRoute: () => rootRoute,
  path: '/debris-calculator',
  component: DebrisCalculatorPage,
});

